<div class="page-layout flex-vertical gap-32 align-self-stretch">
  <oui-banner
    *ngIf="isNotHabilitedWarning"
    title="Vous n'avez aucune habilitation active en placement"
    declination="error"
    [showCloseButton]="false"
    [action]="noHabilAction"></oui-banner>
  <div class="flex-horizontal flex-center width-100pc">
    <h4 class="flex-none">Mes fiches conseil</h4>
    <div class="flex-auto"></div>
    <div class="flex-none">
      <div class="flex-horizontal height-100pc gap-16">
        <app-create-fiche-conseil></app-create-fiche-conseil>
      </div>
    </div>
  </div>
  <app-fiche-conseil-dashboard></app-fiche-conseil-dashboard>
  <ng-template #loading>
    <oui-loading class="flex-horizontal width-100pc justify-center flex-center min-height-500"></oui-loading>
  </ng-template>
</div>
